import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import AppRoutes from "./routes/routes";
import { Toaster } from "./components/ui/toaster";
import "./globals.css";
import { ErrorBoundary } from "./components/error-boundary/ErrorBoundary";
import { initSentry } from "./lib/sentry";
import { subscribeAuthIdentity } from "./lib/sentryIdentity";
import { iniciarPlataforma } from "@/platform";

initSentry();
subscribeAuthIdentity();

async function arrancar() {
  // Antes de la primera pantalla: en el escritorio, si el flag `OFFLINE_ENABLED`
  // prende la caja. Todo lo que se dibuja ya ve `pos` como quedó. No rechaza.
  await iniciarPlataforma().catch(() => undefined);

  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <ErrorBoundary>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>

        <Toaster />
      </ErrorBoundary>
    </StrictMode>
  );
}

void arrancar();
